import { render, staticRenderFns } from "./GlobalSports.vue?vue&type=template&id=331d32cf&scoped=true"
import script from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSports.vue?vue&type=style&index=0&id=331d32cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d32cf",
  null
  
)

export default component.exports